import React from 'react';
import { Spinner } from '@blueprintjs/core';
import '../../assets/style/loader.scss';

type Props = {
  className?: string;
};

const SectionLoader = ({ className }: Props) => (
  <div className={className || 'section-loader'}>
    <Spinner size={100} scale={100} />
  </div>
);

export default SectionLoader;
